module.exports = __webpack_public_path__ + "img/spinner.848fc4b1.png";